<template>
  <nav class="navbar navbar-expand-lg ">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
        </button>
      </div>
      <a class="navbar-brand">{{this.$route.name}}</a>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-expanded="false"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav">
          <drop-down position="right">
            <font-awesome-icon slot="title" icon="user-cog" class="beast-icon" size="lg"></font-awesome-icon>

            <li class="dropdown-item">
              <router-link to="/help">
                <font-awesome-icon icon="question-circle"></font-awesome-icon>
                Help Center
              </router-link>
            </li>
            <li class="dropdown-item">
              <router-link to="/profile">
                <font-awesome-icon icon="user"></font-awesome-icon> Profile
              </router-link>
            </li>
            <li class="divider">
            </li>
            <li class="dropdown-item">
              <button class="text-danger" @click="logout">
                <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
                Log out
              </button>
            </li>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    user() {
      return this.$auth.user();
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    logout() {
      this.$auth
        .logout()
        .then(() => {
          this.$router.push("/auth/login");
        });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  }
};

</script>
<style scoped>
</style>
